//#region src/objectUtils.ts
function isObject(value) {
	return typeof value === "object" && value !== null;
}
function keys(obj) {
	return Object.keys(obj);
}
function pick(object, keys) {
	const result = {};
	for (const key of keys) result[key] = object[key];
	return result;
}
function pickBy(object, predicate) {
	return Object.fromEntries(Object.entries(object).filter(([_key, value]) => predicate(value)));
}
function isEqual(a, b) {
	if (Object.is(a, b)) return true;
	if (a === null || b === null || a === void 0 || b === void 0) return false;
	if (typeof a !== typeof b) return false;
	if (typeof a !== "object") return false;
	if (Array.isArray(a) !== Array.isArray(b)) return false;
	if (Array.isArray(a) && Array.isArray(b)) {
		if (a.length !== b.length) return false;
		for (let i = 0; i < a.length; i++) if (!isEqual(a[i], b[i])) return false;
		return true;
	}
	if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
	if (a instanceof RegExp && b instanceof RegExp) return a.toString() === b.toString();
	const aKeys = Object.keys(a);
	const bKeys = Object.keys(b);
	if (aKeys.length !== bKeys.length) return false;
	for (const key of aKeys) {
		if (!bKeys.includes(key)) return false;
		if (!isEqual(a[key], b[key])) return false;
	}
	return true;
}
function isPlainObject(value) {
	return isObject(value) && value.constructor === Object;
}
function isFunction(value) {
	return typeof value === "function";
}
function sortBy(arr, ...sortFns) {
	return [...arr].sort((a, b) => {
		for (const [sortFn, order] of sortFns) {
			const aIsHigher = order === "asc" ? 1 : -1;
			const bIsHigher = order === "asc" ? -1 : 1;
			let aValue = sortFn(a);
			let bValue = sortFn(b);
			if (typeof aValue === "boolean") aValue = aValue ? 1 : 0;
			if (typeof bValue === "boolean") bValue = bValue ? 1 : 0;
			if (aValue === void 0 && bValue === void 0) continue;
			if (aValue === void 0) return bIsHigher;
			if (bValue === void 0) return aIsHigher;
			if (aValue > bValue) return aIsHigher;
			else if (aValue < bValue) return bIsHigher;
		}
		return 0;
	});
}
function isString(value) {
	return typeof value === "string";
}
function mapValues(object, fn) {
	const result = {};
	for (const key in object) result[key] = fn(object[key], key);
	return result;
}
function memoize(fn) {
	const cache = /* @__PURE__ */ new Map();
	return ((...args) => {
		const key = JSON.stringify(args);
		if (cache.has(key)) return cache.get(key);
		const result = fn(...args);
		cache.set(key, result);
		return result;
	});
}
function entries(object) {
	return Object.entries(object);
}
function nullToUndefinedValues(object) {
	return mapValues(object, (value) => value === null ? void 0 : value);
}
function isKey(maybeKey, object) {
	return maybeKey !== null && maybeKey !== void 0 && maybeKey in object;
}

//#endregion
export { entries, isEqual, isFunction, isKey, isObject, isPlainObject, isString, keys, mapValues, memoize, nullToUndefinedValues, pick, pickBy, sortBy };